// extracted by mini-css-extract-plugin
module.exports = {"Report-card-box":"b1","reportCardBox":"b1","report-img-wrap":"b2","reportImgWrap":"b2","report-title":"b3","reportTitle":"b3","report-date":"b4","reportDate":"b4"};